var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2667 12.9834L6.88333 8.60006C6.55 8.88895 6.16111 9.11395 5.71667 9.27507C5.27222 9.43618 4.8 9.51673 4.3 9.51673C3.1 9.51673 2.08333 9.10007 1.25 8.26673C0.416667 7.4334 0 6.42784 0 5.25007C0 4.07229 0.416667 3.06673 1.25 2.2334C2.08333 1.40007 3.09444 0.983398 4.28333 0.983398C5.46111 0.983398 6.46389 1.40007 7.29167 2.2334C8.11944 3.06673 8.53333 4.07229 8.53333 5.25007C8.53333 5.72784 8.45556 6.18895 8.3 6.6334C8.14444 7.07784 7.91111 7.49451 7.6 7.8834L12 12.2501L11.2667 12.9834ZM4.28333 8.51673C5.18333 8.51673 5.95 8.19729 6.58333 7.5584C7.21667 6.91951 7.53333 6.15007 7.53333 5.25007C7.53333 4.35007 7.21667 3.58062 6.58333 2.94173C5.95 2.30284 5.18333 1.9834 4.28333 1.9834C3.37222 1.9834 2.59722 2.30284 1.95833 2.94173C1.31944 3.58062 1 4.35007 1 5.25007C1 6.15007 1.31944 6.91951 1.95833 7.5584C2.59722 8.19729 3.37222 8.51673 4.28333 8.51673Z",
    fill: "white",
    fillOpacity: 0.92
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.56ba5b05c8a9cacaf6d51d835344c164.svg";
export { ForwardRef as ReactComponent };